module.exports = __webpack_public_path__ + "static/media/cancel.77cd9f7d.svg";